import TipoOptions from '@app/types/core.types';
import { OptionProps } from '@digital/ui';
import api from '../api';
import { IAcaoFornecedor } from './sasDocumentoOrdemCompra';
import { Usuario } from '../usuario';
import Axios from 'axios';
import { getJwt } from '@app/helpers';
import { vtObjToQueryString } from '@app/helpers/objHelper';
import { PaginationResult } from '../pagination';
import { toEndOfDayISOString, toStartOfDayISOString } from '@app/helpers/dateTimeFormats';
const controller = 'ordemCompra';

export interface Vendor {
  id: string;
}

export interface FitroOrdemCompraPorStatusCodigo {
  codigos: number[];
  consultaStatusConcluido: boolean;
  fornecedorOcId?: string;
  filtroGestor?: boolean;
  periodoInicio? : any;
  periodoFim? : any;
}

export interface OrdemCompraResult {
  tipo: string;
  demanda: string;
  area: string;
  diretoria: string;
  oc: number;
  tipoServico: string;
  valorOrdemCompra: string;
  ptr: string;
  statusPrazo: string;
  ddi: string;
  compradorId: string;
  id: string;
  numeroRc: string;
  departamento: string;
  isDirecionado: boolean;
  isEmergencial: boolean;
  isEmergencialString: string;
  isDirecionadoString: string;
  dataOc: string;
  statusOrdemCompra: string;
  statusOrdemCompraExibicao: string;
  statusOrdemCompraExibicaoId: string;
  modalidadeContratoTotvs: string;
  
  elegibilidadeGovernanca: string;
  visitaTecnica: string;
  demandaIdentificador: string;
  
  numeroContrato: number;
  NumeroPedido: number;
  escopo: string;
  updatedAt: string;
  ultimaAcao?: IAcaoFornecedor;
}

export interface CondicoesComerciasProps {
  contratoId: string;
  aditivoId: string;
  ordem: number;
  descricao: string;
  valorTotalAcumulado: number;
  valorTotalAcumuladoFormatado: string;
  valorAditivo: number;
  variacaoCtOriginal: number;
  inicioVigencia: string;
  terminoVigencia: string;
  prazoAcumulado: number;
  variacaoPrazo: number;
}

export interface SasPropostaProps {
  avaliacaoDdi?: string;
  avaliacaoFinanceira?: string;
  id: string;
  nomeSasFornecedor: string;
  numeroVencedor: number;
  parecerTecnico?: string;
  condicaoPagamento?: string;
  valorPropostaComercial: number;
  valorPropostaEqualizada: number;
  valorPropostaInicial: number;
}

export interface OrdemCompraDadosGerais {
  analistaSuprimentos: string;
  anexoId: string;
  anexoNome: string;
  areaRequisitante: string;
  caracteristicaOc: string;
  condicoesComerciais: CondicoesComerciasProps[];
  contrato: number;
  id: string;
  invalid: boolean;
  justificativaContratacao: string;
  menorPcEqualizada: number;
  modalidadeContratoTotvs: string;
  moeda: string;
  naturezaContabil: number;
  nomePropostaPremiada: string;
  notifications: any[];
  numeroOc: number;
  numero?: number;
  objetoASerContratado: string;
  objeto?: string;
  orcamento: number;
  ordemCompraId: string;
  prazoExecucao: number;
  previstoOrcamento: string;
  sasPropostas: SasPropostaProps[];
  solicitante: string;
  terminoVigenciaAditivo: string;
  tipoOc: number;
  valid: boolean;
  valorAContratar: number;
  valorAditivo: number;
  valorPropostaPremiada: number;
  gerenteCompras: string;
  gerenteSuprimentos: string;
  diretorEspecifico: string;
  diretoriaComercial: string;
  diretorPresidente: string;
  historicoProcessoCompra: string;
  statusCodigo: number;
  demandaId: string;
  compradorId: string;
  dataEmissao: Date;
  isFornecedorDirecionado: boolean;
  isVisitaTecnica: boolean;
  isEmergencial: boolean;
  gestorTecnicoId: string;
  gerenteAreaId: string;
  minimoProponentes: number;
  comentarioGerenteArea: string;
  statusOrdemCompraId: string;
  statusCartaAgradecimento: boolean;
  dataFinal: Date;
  dataInicio: Date;
  modalidadeContrato: number;
  controlePrecoQtde: number;
  tipoControleContrato: number;
  unidadeMedicao: number;
  caracteristicaItem: number;
  compradorOriginal: string;
  docuSignId: string;
  docuSignIdCT: string;
  stepId: string;
  fluxoProcessoId: string;
  statusEnvioDdi: string;
  handover: boolean;
  contratoEmitido: boolean;
  contratoId: string;
  statusAprovacaoContrato: string;
  statusAprovacaoContratoTotvs: string;
  statusAprovacaoAditivo: string;
  statusAprovacaoAditivoTotvs: string;
  tipo: number;
  tipoContrato: string;
  valorTotalContratacao: number;
  rodadasNegociacoes?: any[];
  valorTotalParaAditivo?: number;
  empresaParaAditivo?: string;
  isEmailVencedorEnviado: boolean;
  numeroAditivo?: number;
  isPrazo?: boolean;
  isValorSemAcrescimoEscopo?: boolean;
  dataFinalWidget?: Date;
  valorTotalWidget?: number;
  valorAditivoOC?: number;
  valorAditivoOCExtenso?: string;
  statusExpectativa: string;
  necessitaEnviarAprovacao: boolean;
  valorCalcRH: number;
  reloadPage : boolean;
  consultiva : boolean;
  demandaAtiva : boolean;
}

export interface OrdemCompraDadosIdentificacao {
  id: string;
  reqCompra: number;
  numero: number;
  dataEmissao: Date;
  compradorId: string;
  compradorNome: string;
  statusOrdemCompraFluxoProcessoTexto: string;
  statusCodigo: number;
  statusOrdemCompraId: string;
  statusOrdemCompraTexto: string;
  objeto: string;
  justificativaCancelamento: string;
}

export interface OrdemCompraAbas {
  fluxoProcesso: Boolean;
  dadosGerais: Boolean;
  integracaoContrato: Boolean;
  relatorioHomologacao: Boolean;
  checklistReajuste: Boolean;
  historico: Boolean;
  sumarioOc: Boolean;
}

export interface UpdateUsuarioCompradorOrdemCompraForm {
  ordemCompraId: string;
  usuarioCompradorId: string;
}

export interface FiltrosTabela {
  diretoria: TipoOptions[];
  area: TipoOptions[];
}

export interface RespostaFornecedorOc {
  ordemCompraId: string;
  fornecedorOcId: string;
  respostaFornecedor: boolean;
}

export interface HistoricoOrdemCompra {
  id: string;
  ordemCompraId: string;
  usuarioResponsavel?: string;
  statusAnterior?: string;
  novoStatus?: string;
  descricao?: string;
  dataHoraFormatada: string;
  comentario: string;
}

export interface Comprador { }

export interface Comentario {
  id: string;
  mensagem: string;
  nomeDoUsuario: string;
  dataHoraInclusao: Date;
}

export const ObterComentariosOrdemCompraId = (id: any) =>
  api.get<Comentario[]>(`ordemCompra/ObterComentariosOrdemCompraId/${id}`);

export const SalvarComentario = (form: any) =>
  api.post('ordemCompra/createComentario', form, {
    disableNotification: 'true',
  });

export const getHistoricoOrdemCompra = (id: string) =>
  api.get<HistoricoOrdemCompra[]>(`ordemCompra/getHistoricoOrdemCompra/${id}`);
export const getVendorList = (demandaId: string) => api.get(`ordemCompra/GetVendorList/${demandaId}`);
export const saveVendor = (values: any) => api.put(`ordemCompra/SaveVendor`, values);
export const excluirVendor = (id: string) => api.delete(`ordemCompra/ExcluirVendor/${id}`);

interface IAvancarOrdemCompra {
  ordemCompraRodadaNegociacaoId?: string;
  pularProximaEtapa?: boolean;
  fluxoProcessoId?: string;
  validacaoSomente?: boolean;
  dataConclusaoEtapa?: Date;
}

export const avancarOrdemCompra = (ordemCompraId: string, filtro?: IAvancarOrdemCompra, hasNotification = true) => {
  var query = vtObjToQueryString(filtro);
  return api.put(`ordemCompra/${ordemCompraId}/avancar?${query}`, undefined, hasNotification == false && {
    disableNotification: 'true',
  });
};

// export const validarStep = (stepId: string, id: string, ordemCompraRodadaNegociacaoId?: string) => {
//   const ocrnId = ordemCompraRodadaNegociacaoId ? `?ordemCompraRodadaNegociacaoId=${ordemCompraRodadaNegociacaoId}` : "";
//   return api.get(`ordemCompra/validarStep/${stepId}/${id}${ocrnId}`)
// }

export const cancelar = (id: string, justificativa: string, arquivo?: File, enviarEmail?: boolean) => {
  const formData = new FormData();
  formData.append("id", id);
  formData.append("justificativa", justificativa);
  if (arquivo) {
    formData.append("arquivo", arquivo);
  }
  if (enviarEmail !== undefined) {
    formData.append("EnviarEmail", String(enviarEmail));
  }
  return api.post("ordemCompra/Cancelar", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const devolver = (id: string, justificativa: string) => api.post(`ordemCompra/Devolver`, { id, justificativa });

export const ExportarOrdemDeCompraWithParams = async (
  filtroBase: Omit<FitroOrdemCompraPorStatusCodigo,'fornecedorOcId'>,
  filters?: Record<string, (string | number)[] | null>,
  sorter?: any,

) => {
  const params = new URLSearchParams();

  // Filtros fixos
  params.append('codigos', filtroBase.codigos.join(','));
  params.append('consultaStatusConcluido', String(filtroBase.consultaStatusConcluido));
  params.append('filtroGestor', String(filtroBase.filtroGestor));

  if (filtroBase.periodoInicio && filtroBase.periodoFim) {
    params.append('periodoInicio', toStartOfDayISOString(filtroBase.periodoInicio));
    params.append('periodoFim', toEndOfDayISOString(filtroBase.periodoFim));
  }

  
  // Filtros dinâmicos
  Object.entries(filters || {}).forEach(([key, values]) => {
    if (values) {
      values.forEach(value => params.append(key, String(value)));
    }
  });

  // Ordenação
  if (sorter && sorter.field && sorter.order) {
    params.append('ordenarPor', sorter.field);
    params.append('ordem', sorter.order === 'ascend' ? 'ASC' : 'DESC');
  }

  // GET

  const url = `/api/ordemCompra/ExportarExcel?${params.toString()}`;

  const resp = await Axios.get(url, {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
  });

  const now = new Date();
  const timestamp = `${now.getFullYear()}${(now.getMonth() + 1)
    .toString()
    .padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}_${now
    .getHours()
    .toString()
    .padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}${now
    .getSeconds()
    .toString()
    .padStart(2, '0')}`;

  const urlBlob = window.URL.createObjectURL(new Blob([resp.data]));
  const link = document.createElement('a');
  link.href = urlBlob;
  link.setAttribute('download', `exportacao_ordem_compra_${timestamp}.xlsx`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  
};


export const ExportarOrdemDeCompra = async (filtroBase: {
  codigos: number[];
  consultaStatusConcluido: boolean;
  filtroGestor: boolean;
  size: number;
}) => {
  // Função para serializar filtroBase para query string
  const buildQueryString = (params: Record<string, any>) => {
    const queryParts: string[] = [];

    for (const key in params) {
      const value = params[key];
      if (Array.isArray(value)) {
        value.forEach(v => {
          queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(v)}`);
        });
      } else {
        // Converte boolean para string
        queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
      }
    }

    return queryParts.join('&');
  };

  const queryString = buildQueryString(filtroBase);
  const url = `/api/ordemCompra/ExportarExcel?${queryString}`;

  const resp = await Axios.get(url, {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
  });

  const now = new Date();
  const timestamp = `${now.getFullYear()}${(now.getMonth() + 1)
    .toString()
    .padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}_${now
    .getHours()
    .toString()
    .padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}${now
    .getSeconds()
    .toString()
    .padStart(2, '0')}`;

  const urlBlob = window.URL.createObjectURL(new Blob([resp.data]));
  const link = document.createElement('a');
  link.href = urlBlob;
  link.setAttribute('download', `exportacao_ordem_compra_${timestamp}.xlsx`);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const getAllOrdemCompraPorStatusCodigo = (filtro: FitroOrdemCompraPorStatusCodigo) => {
  return api.post<OrdemCompraResult[]>('ordemCompra/getAllOrdemCompraPorStatusCodigo', filtro, {
    disableNotification: true,
  });
};


export const getAllOrdemCompraPorStatusCodigoWithParams = (
  filtroBase: Omit<FitroOrdemCompraPorStatusCodigo,'fornecedorOcId'>,
  page: number,
  size: number,
  filters?: Record<string, (string | number)[] | null>,
  sorter?: any,

) => {
  const params = new URLSearchParams();

  // Filtros fixos
  params.append('codigos', filtroBase.codigos.join(','));
  params.append('consultaStatusConcluido', String(filtroBase.consultaStatusConcluido));
  params.append('filtroGestor', String(filtroBase.filtroGestor));

  if (filtroBase.periodoInicio && filtroBase.periodoFim) {
    params.append('periodoInicio', toStartOfDayISOString(filtroBase.periodoInicio));
    params.append('periodoFim', toEndOfDayISOString(filtroBase.periodoFim));
  }


  // Paginação
  params.append('page', String(page));
  params.append('size', String(size));

  // Filtros dinâmicos
  Object.entries(filters || {}).forEach(([key, values]) => {
    if (values) {
      values.forEach(value => params.append(key, String(value)));
    }
  });

  // Ordenação
  if (sorter && sorter.field && sorter.order) {
    params.append('ordenarPor', sorter.field);
    params.append('ordem', sorter.order === 'ascend' ? 'ASC' : 'DESC');
  }

  // GET
  return api.get<PaginationResult<OrdemCompraResult>>(
    `ordemCompra/getAllOrdemCompraPorStatusCodigo?${params.toString()}`,
    {},
    { disableNotification: true }
  );
};

export const getAllCompradores = () => {
  return api.get<OptionProps[]>(`ordemCompra/getAllCompradores`);
};

export const updateUsuarioCompradorOrdemCompra = (values: UpdateUsuarioCompradorOrdemCompraForm) =>
  api.put(`ordemCompra/updateUsuarioCompradorOrdemCompra`, values);
export const getAbas = (id: string) => api.get<OrdemCompraAbas>(`ordemCompra/Abas/${id}`);
export const getDadosGerais = (id: string) => api.get<OrdemCompraDadosGerais>(`ordemCompra/GetDadosGerais/${id}`);
export const getDadosIdentificacao = (id: string) => api.get<OrdemCompraDadosIdentificacao>(`ordemCompra/GetDadosIdentificacao/${id}`);
export const getDadosData = (id: string, ordemCompraFluxoProcessoId?: string, ordemCompraRodadaNegociacaoId?: string) => {
  const params = vtObjToQueryString({ ordemCompraFluxoProcessoId, ordemCompraRodadaNegociacaoId });
  return api.get(`ordemCompra/GetDadosData/${id}?${params}`);
};
export const GetAbaAditivo = (id: string) => api.get<any>(`ordemCompra/getAbaAditivo/${id}`);

export const getCartaConviteCorpoEmail = (id: string) =>
  api.get<{ corpoEmail: string; objeto: string }>(`ordemCompra/cartaConviteCorpoEmail/${id}`);

export const enviarCartaConviteFornecedor = (data: {
  id: string;
  envioEmail: boolean;
  corpoEmailCustomizado: string;
  dataCartaConvite?: string;
  objetoDaDemanda?: string;
}) => api.post(`ordemCompra/enviarCartaConviteFornecedor`, data);
export const enviarCartaEsclarecimentoTecnicoFornecedor = (id: string, enviarEmail: boolean, dataLimite?: string) => api.post(`ordemCompra/EnviaCartaEsclarecimentoTecnicoFornecedor`, { id, envioEmail: enviarEmail, dataLimite });
export const enviarSolicitarPropostaTecnicaFornecedor = (id: string, enviarEmail: boolean, dataLimite?: string) => api.post(`ordemCompra/EnviaCartaPropostaTecnicaFornecedor`, { id, envioEmail: enviarEmail, dataLimite });


//#region GESTOR TECNICO
export const getAllOrIdGestorTecnico = () => {
  return api.get<Usuario[]>(`ordemCompra/gestortecnicos`);
};

export const getAllOrIdGestorTecnicoOptions = () =>
  getAllOrIdGestorTecnico().then(data => (data || []).map(a => ({ text: a.nome, value: (a.id || '').toString() } as TipoOptions)));

export interface PostGestorTecnico {
  ordemCompraId: string;
  gestorTecnicoId: string;
}

export const PostGestorTecnico = (values: PostGestorTecnico) => {
  return api.post<PostGestorTecnico[]>(`ordemCompra/gestortecnicos`, values);
};

export const notificarGestorTecnico = (ordemCompraId: string) => {
  return api.put<any>(`ordemCompra/notificarGestorTecnico/${ordemCompraId}`);
};
//#endregion

//#region GERENTE AREA
export const getAllOrIdGerenteArea = () => {
  return api.get<Usuario[]>(`ordemCompra/gerenteArea`);
};

export const getAllOrIdGerenteAreaOptions = () =>
  getAllOrIdGerenteArea().then(data => (data || []).map(a => ({ text: a.nome, value: (a.id || '').toString() } as TipoOptions)));

export interface PostGerenteArea {
  ordemCompraId: string;
  gerenteAreaId: string;
}

export const PostGerenteArea = (values: PostGerenteArea) => {
  return api.post<PostGerenteArea>(`ordemCompra/gerenteArea`, values);
};

export interface PutComentarioGerenteArea {
  ordemCompraId: string;
  comentarioGerenteArea: string;
}

interface INotificarVencedorAreaTecnica {
  ordemCompraId: string;
  destinatarios: string[];
  enviarEmail?: boolean;
}


export const PutComentarioGerenteArea = (values: PutComentarioGerenteArea) => {
  return api.put<PutComentarioGerenteArea>(`ordemCompra/gerenteArea/comentario/` + values.ordemCompraId, values);
};
//#endregion

export const verificarAnexoRelatorioHomologacao = (id: string) =>
  api.get(`ordemCompra/VerificarAnexoRelatorioHomologacao/${id}`);

export const getAllModalidadesContrato = () => api.get(`ordemCompra/getSasModalidadeContrato`);

export const getAllModalidadesContratoOptions = () =>
  getAllModalidadesContrato().then(data => (data || []).map(a => ({ text: a.descricao, value: a.codigo })));

export const updateInformacoesComplementares = (values: any) => {
  const form = new FormData();
  form.append('id', values['id']);
  form.append('modalidadeContrato', values['modalidadeContrato']);
  form.append('tipoControleContrato', values['tipoControleContrato']);
  form.append('unidadeMedicao', values['unidadeMedicao']);
  form.append('caracteristicaItem', values['caracteristicaItem']);
  form.append('controlePrecoQtde', values['controlePrecoQtde']);
  form.append('narrativaContrato', values['narrativaContrato']);
  form.append('dataInicio', values['dataInicio']);
  form.append('dataFinal', values['dataFinal']);
  return api.put('ordemCompra/updateInformacoesComplementares', form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const alterarStatusOc = (ocId: string, novoStatusId: string) =>
  api.post(`ordemCompra/alterarStatus`, {
    ordemCompraId: ocId,
    novoStatusId,
  });

export const avancarAprovacaoGerenteMinimoProponentes = (form) =>
  api.put('ordemCompra/AvancarAprovacaoGerenteMinimoProponentes', form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

 export const RetornarFluxoProponentes = (form) =>
  api.post('ordemCompra/RetornarFluxoProponentes', form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  
export const enviarDdiFornecedor = (ordemCompraId: string, enviarEmail: boolean) =>
  api.put(`ordemCompra/enviarDdiFornecedor/${ordemCompraId}/${enviarEmail}`);

export const desobrigarDdiFornecedor = (form: any) => 
{
  return api.post(`ordemCompra/desobrigarDdiFornecedor/`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};


export const baixarProponentesSemConfide = async (ordemCompraId: string) => {
  var url = window.location.origin + `/api/ordemCompra/baixarProponentesSemConfide/${ordemCompraId}`;
  await Axios.get(url, {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
    responseType: 'blob',
  }).then(resp => {
    const url = window.URL.createObjectURL(new Blob([resp.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'proponentes_sem_Relatorio_Financeiro.xlsx');
    link.setAttribute('id', 'downloadElement');
    document.body.appendChild(link);
    link.click();
    document.getElementById('downloadElement').outerHTML = '';
  });
};


export const enviarEmailCartaAgradecimento = (ordemCompraId: string, enviarEmail: boolean) =>
  api.post(`ordemCompra/${ordemCompraId}/enviarEmailCartaAgradecimento/${enviarEmail}`);

export const getContratoHistoricoAprovacaoTotvs = (ordemCompraId: string) =>
  api.get<any[]>(`ordemCompra/GetContratoHistoricoAprovacaoTotvs?ordemCompraId=${ordemCompraId}`);

export const getAtualizarAprovacaoContrato = (ordemCompraId: string) =>
  api.get<any[]>(`ordemCompra/${ordemCompraId}/atualizarAprovacaoContrato`);

export const editDataConclusaoEtapa = (values: any) => {
  return api.put(`${controller}/editDataConclusaoEtapa`, values);
};

export const verificaUsuarioPodeAcessarOrdemCompra = (ordemcompraId: string) => {
  return api.get(`${controller}/${ordemcompraId}/verificaUsuarioPodeAcessarOrdemCompra`);
};

export const verificaAnexoMarcadoComoExibirFornecedor = (ordemcompraId: string) => {
  return api.get(`${controller}/${ordemcompraId}/verificaAnexoMarcadoComoExibirFornecedor`);
};

export const enviarCartaContratada = (form: any) => api.post(`ordemCompra/enviarCartaContratada`, form);

export const enviarVencedorEAreaTecnica = (values: INotificarVencedorAreaTecnica) => api.post(`ordemCompra/enviarEmailVencedor`, values);

export const updateAbaAditivoCommand = (values: any) => api.post(`ordemCompra/updateAbaAditivoCommand`, values);
export const atualizarStatusOrdemCompra = (values: any) => api.post(`ordemCompra/atualizarStatusOrdemCompra`, values);

export const criarConsultiva = (values: any) => api.post(`ordemCompra/CriarConsultiva`, values);



export const getContratoSasHistoricoExpectativaCompraTotvs = (ordemCompraId: string, ehAtualizar = false) =>
  api.get<any[]>(`ordemCompra/GetContratoSasHistoricoExpectativaCompraTotvs?ordemCompraId=${ordemCompraId}&ehAtualizar=${ehAtualizar}`);

  
export const getIsAjusteOrcamentario = (ordemCompraId: string) =>
api.get<any[]>(`ordemCompra/ajusteOrcamentario/${ordemCompraId}`);

export interface IEnviarAjusteOrcamentarioCommand {
    ordemCompraId: string;
    isAjusteManualValor?: boolean;
    valorAjusteManual?: number;
    criterioAjusteValor?: number;
    isAjusteManualPrazo?: boolean;
    novoPrazo?: string; // ISO 8601 - para Aditivo
    novoPrazoMeses?: number; // para Nova Contratação
    justificativa?: string;
}

export const enviarAjusteOrcamentario = (dados: IEnviarAjusteOrcamentarioCommand) => {
    return api.put(`${controller}/EnviarAjusteOrcamentario`, dados, { disableNotification: true });
};


export const AtivarDemandaConsultivaCommand = (values: any) => {
  return api.post(`${controller}/AtivarDemandaConsultiva`,values);
};

export const ativarNegociacaoMinutaContratual = (ordemCompraId: string, enviarEmail: boolean, dataLimite: string | undefined, arquivo: File) => {
  const form = new FormData();
  form.append('arquivo', arquivo);
  if (dataLimite) form.append('dataLimite', dataLimite);
  return api.post(`${controller}/AtivarNegociacaoMinutaContratual/${ordemCompraId}/${enviarEmail}`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const reenviarNegociacaoMinutaContratual = (
  ordemCompraId: string,
  sasPropostaId: string,
  observacao: string,
  dataLimite: string | undefined,
  arquivo: File
) => {
  const form = new FormData();
  form.append('ordemCompraId', ordemCompraId);
  form.append('sasPropostaId', sasPropostaId);
  form.append('observacao', observacao || '');
  if (dataLimite) form.append('dataLimite', dataLimite);
  form.append('arquivo', arquivo);
  return api.post(`${controller}/ReenviarNegociacaoMinutaContratual`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

